import { Player } from '@lottiefiles/react-lottie-player';
import React, { FC } from 'react';
import styled from 'styled-components';

import Button, { IButtonProps } from '@ui/atoms/Button';

import Loading from '@assets/lottie/Loading.json';

export interface ISubmitButtonProps extends IButtonProps {
	submitting?: boolean;
}

const StyledPlayer = styled(Player)`
	width: 9rem;
	height: 5.5rem;
`;

const SubmitButton: FC<ISubmitButtonProps> = ({
	submitting,
	type = 'submit',
	disabled,
	...props
}) => {
	const isDisabled = disabled || submitting;
	return (
		<Button
			{...props}
			type={type}
			dataCy={props.label?.toString()}
			label={submitting ? <StyledPlayer autoplay loop src={Loading} /> : props.label}
			disabled={isDisabled}
		/>
	);
};

export default styled(SubmitButton)``;
